import React from "react"
import styles from './About.module.scss'
import SText from "../../../components/SText";
import PText from "../../../components/PText";
import Colors from "../../../components/utils/Colors";
import { NavLink } from "react-router-dom";
import { colorToFilter } from "../../../components/utils/ColorFilter";
import back from "../../../assets/images/cart/goBack.svg";

const About = () => {

    return <div className={ styles.wrapper }>
        <div className={ styles.header }>
            <NavLink to={ '/' }>
                <div className={ styles.goBack }><img style={ { filter: colorToFilter('#383838') } } src={ back } /></div>
            </NavLink>
            <div><SText size={ 26 } lineHeight={ 20 } weight={ 700 } color={ Colors.black }>{ 'О нас' }</SText></div>
        </div>
        <div className={ styles.container }>
            <h1>О нас</h1>
            <div style={ { marginBottom: 16 } }>
                <PText size={ 18 } lineHeight={ 24 }><b>SeasonMarket</b> — удобная доставка свежих и полезных продуктов высокого качества. У нас вы найдёте всё: от привезенных самолетом фруктов и фермерских молочных изделий до домашнего мяса и охлаждённой рыбы.</PText>
                <PText size={ 18 } lineHeight={ 24 }>{ 'Мы лично отбираем свежие продукты у проверенных поставщиков, аккуратно упаковываем и доставляем в удобное время с точным интервалом.' }</PText>
                <PText size={ 18 } lineHeight={ 24 }>{ 'Ставка на сезонность и натуральность: только свежие овощи, фрукты и ягоды, выращенные с заботой.' }</PText>
                <PText size={ 18 } lineHeight={ 24 }>{ 'Оформляйте заказ онлайн в пару кликов, и вкусные продукты уже в пути к вашему дому.' }</PText>
                <PText size={ 18 } lineHeight={ 24 }><b>SeasonMarket</b> — лучшее от природы с комфортом для вас!</PText>
            </div>
        </div>
    </div>
}

export default About